export const ABORT_REASON = "promise be aborted";
export function abortedPromise(originPromise) {
    let abortFunc = null;
    const abortPromise = new Promise(function (...promiseArgs) {
        const [, reject] = promiseArgs;
        abortFunc = function () {
            reject(ABORT_REASON);
        };
    });
    const promiseChain = Promise.race([originPromise, abortPromise]);
    promiseChain.abort = abortFunc;
    return promiseChain;
}
